import classNames from "classnames";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import {
  DropdownArrowProps,
  NavigationBarWrapperProps,
  PageLayoutWrapperProps,
  ParentTabWrapperProps,
  SidebarTogglerProps,
  TabIconAndTextProps,
} from "../../Types";
import { useState } from "react";
import { Tooltip } from "@mui/material";
import { handleChildTabClick } from "../../Utils";

export const PageLayoutWrapper = (props: PageLayoutWrapperProps) => {
  const { children, customClasses = "", ...wrapperStyles } = props;

  return (
    <div
      className={classNames(
        "ds-font-inter tw-fixed tw-inset-0 tw-flex tw-h-screen tw-w-screen tw-flex-col tw-bg-white",
      )}
      style={{
        ...wrapperStyles,
      }}
    >
      {props?.children}
    </div>
  );
};

export const NavigationBarWrapper = (props: NavigationBarWrapperProps) => {
  const { children, expanded } = props;

  return (
    <div
      className={classNames(
        "tw-relative tw-h-full tw-border-r tw-border-solid tw-border-[#111C361F]  tw-transition-all tw-duration-200 tw-ease-in",
        expanded ? "tw-w-3/12 tw-max-w-[226px]" : "tw-w-1/12  tw-max-w-[64px]",
      )}
    >
      {children}
    </div>
  );
};

export const SidebarToggler = (props: SidebarTogglerProps) => {
  const { expanded, onClick } = props;
  const [showTootip, setShowTooltip] = useState(false);

  return (
    <Tooltip
      open={showTootip}
      title={expanded ? "Collapse" : "Expand"}
      className="tw-absolute -tw-right-0  tw-top-[60px]"
      classes={{
        tooltip: "!tw-bg-[#111C36] tw-text-[12px]/[16px] tw-font-normal tw-py-[4px] tw-px-[8px] tw-rounded-[6px] ",
      }}
    >
      <span
        className={classNames(
          "tw-z-[9999] tw-flex tw-translate-x-1/2 tw-cursor-pointer tw-rounded-full tw-border tw-border-solid tw-border-[#2B74D8] tw-bg-white tw-text-[8px] tw-transition-transform tw-duration-100 tw-ease-in",
          expanded ? "tw-rotate-0" : "tw-rotate-180",
        )}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={onClick}
      >
        <KeyboardArrowLeft className="!tw-text-[20px] !tw-text-[#2B74D8]" />
      </span>
    </Tooltip>
  );
};

export const PageContentWrapper = (props) => {
  return (
    <div
      className={classNames(
        "h-full tw-tw-flex tw-relative tw-flex-1 tw-flex-col tw-overflow-auto tw-bg-[#FAFAFA] tw-transition-all tw-duration-200 tw-ease-in",
      )}
    >
      {props.children}
    </div>
  );
};

export const ParentAndChildTabWrapper = (props) => {
  return <div className={classNames("tw-cursor-pointer tw-text-[#111C36E5]")}>{props.children}</div>;
};

export const ParentTabWrapper = (props: ParentTabWrapperProps) => {
  const {
    children,
    isNavbarExpanded,
    id,
    route,
    isParentTabHovered,
    isParentTabActive,
    isParentTabExpanded,
    subNavList,
    onExpandParentTab,
    onHoverTab,
    setAnchorEl,
    isAccessable,
  } = props;

  const history = useHistory();

  const hasSubNavList = !!subNavList;

  function handleParentTabClick() {
    if (!isAccessable) {
      return;
    }

    // if has nested nav links, toggle.
    if (hasSubNavList) {
      const firstAceessableSubtab = subNavList.find((listItem) => listItem.visible && listItem.accessable !== false);
      const route = firstAceessableSubtab?.route;
      const openInNewTab = firstAceessableSubtab?.openInNewTab ?? false;

      if (!isParentTabActive && route) {
        handleChildTabClick(route, openInNewTab);
        return;
      }

      onExpandParentTab(!isParentTabExpanded ? id : null);
      setAnchorEl(null);

      return;
    }
    onExpandParentTab(null);
    history.push(route);
  }

  function getWrapperClasses() {
    if (isParentTabActive && (!hasSubNavList || !isNavbarExpanded || !isParentTabExpanded)) {
      return "tw-bg-[#EAF2FD] tw-text-[#2B74D8]";
    }
    if (isParentTabHovered) {
      return "tw-bg-[#111C360D]";
    }
    return "";
  }

  return (
    <div
      className="tw-relative tw-px-[12px]"
      onMouseLeave={() => {
        onHoverTab(null);
        setAnchorEl(null);
      }}
    >
      <div
        id={"nav-parent-tab-" + id}
        className={classNames(
          "tw-flex tw-items-center tw-justify-between tw-rounded-md tw-p-[8px] tw-text-[14px]/[17px]",
          getWrapperClasses(),
        )}
        onClick={handleParentTabClick}
        onMouseEnter={(e) => {
          onHoverTab(id);
          setAnchorEl(e.currentTarget);
        }}
      >
        {children}
      </div>
    </div>
  );
};

export const TabIconAndText = (props: TabIconAndTextProps) => {
  const { isParentTabActive, isParentTabExpanded, Icon, name, isNavbarExpanded } = props;

  return (
    <div
      className={classNames(
        "tw-flex tw-flex-nowrap tw-items-center tw-gap-[12px] tw-text-nowrap",
        isParentTabActive ? "tw-font-bold" : "tw-font-medium",
      )}
    >
      <span className={classNames("tw-flex", isParentTabActive && isParentTabExpanded ? "tw-text-[#2B74D8]" : "")}>
        <Icon />
      </span>
      <span className={classNames("tw-transition-all", !isNavbarExpanded ? "tw-opacity-0" : "tw-opacity-100")}>
        {name}
      </span>
    </div>
  );
};

export const DropdownArrow = (props: DropdownArrowProps) => {
  const { isParentTabExpanded, isNavbarExpanded } = props;

  return (
    <span
      className={classNames(
        "tw-flex tw-transition-all",
        isParentTabExpanded ? "-tw-rotate-90" : "tw-rotate-0",
        !isNavbarExpanded ? "tw-opacity-0" : "tw-opacity-100",
      )}
    >
      <KeyboardArrowRight fontSize="small" />
    </span>
  );
};
